import { z } from "zod";
import HarvestProcess from "@/pages/HarvestProcess";
import type { ModuleProps } from "../types";

export const harvestComponentsPickerConfig = z.object({});
export type HarvestComponentsPickerConfig = z.infer<typeof harvestComponentsPickerConfig>;

export function HarvestComponentsPickerModule(_props: ModuleProps<HarvestComponentsPickerConfig>) {
  return <HarvestProcess />;
}
